import { FaTimes } from "react-icons/fa";
import { createPortal } from "react-dom";
import styles from "../../styles/viewerModal.module.css";

function PdfViewerModal({ onClose, pdfUrl }) {
  return createPortal(
    <div className="modal-overlay">
      <div className={styles.pdfViewerModal}>
        <div className="modal-header">
          <div>
            <h2 className="title-font-bold">
              Vista previa del certificado
            </h2>

            <span className={styles.pdfViewerSubtitle}>
              Certificado Digital
            </span>
          </div>

          <button
            type="button"
            className="modal-close-btn"
            onClick={onClose}
          >
            <FaTimes />
          </button>
        </div>

        <div className={styles.pdfViewerContainer}>
          <iframe
            src={pdfUrl}
            title="PDF Viewer"
            className={styles.pdfViewerIframe}
          />
        </div>
      </div>
    </div>,
    document.body
  );
}

export default PdfViewerModal;